// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
      //suggestionMode: 'test'
      //suggestionPosition: 'left',
      suggestionWidth: 300,
    enableSearch: true
  }
};

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if(!suggestionElement) suggestionElement = this.suggestionElement;
    if(!searchElement) searchElement = this.searchElement;
    if(!searchBoxId) searchBoxId = this.searchBoxId;
  };

  InstantSearch.prototype.beforeBindEvents = function(id) {
    if(!id) id = this.id;
      jQ(document).ready(function() {
          jQ(document).off('submit', '.search-form, #search-form');
      });
  };



// Only send Weglot request if the current language is different from English
function isWeglotActive() {
    if (!window.Weglot || !window.Weglot.initialized) {
      	return false;
    } else {
    	var currentLang = Weglot.getCurrentLang();
	// Change 'en' to suitable with original language of the store
    	return currentLang !== 'it';
    }
}
  
 InstantSearchApi.beforeCallAsync = function(searchTerm, callInstantSearchApi) {
      // Then use it in our API
      var newSearchTerm = decodeURI(searchTerm);
      if (window.Weglot && window.Weglot.initialized && isWeglotActive()) {
          Weglot.search(newSearchTerm, function(englishTerm) {
      		Globals.instantSearchQueryParams['q'] = englishTerm;
          	callInstantSearchApi();
         	});
      } else {
          callInstantSearchApi();
      }
  }

  // #162047
  InstantSearchApi.beforeCall = function(searchTerm) {
      /* Change the params before calling api */
      Globals.instantSearchQueryParams['locale'] = Shopify.locale;
  }

  jQ(document).find('.main-search__form').on('submit',function(e) {
      location.href = '/search?q='+ Globals.instantSearchQueryParams['q'];
  });
  // End #162047
  
})();